import { defineMessages } from '@transcend-io/internationalization';

export const selectTcfSpecialFeatureMessages = defineMessages(
  'admin-dashboard.ConsentManager.Tcf.TcfStacks.components.SelectTcfSpecialFeature.selectTcfSpecialFeature',
  {
    selectPlaceholder: { defaultMessage: 'Select Special Features...' },
  },
);
